// Current portfolio against a Pure model. Deliberately not built: the appetite
// for it is being tested before the work is spent, so this renders only when
// explicitly asked for with ?model=1 or the ui flag. The layout is here so the
// conversation can happen against something real rather than a description.

export default function ModelComparisonStub({ show, bundle }) {
  if (!show) return null;

  return (
    <section className="asmt-card">
      <div className="asmt-card-head">
        <h2>Your portfolio against the Pure model</h2>
        <span className="asmt-card-note">Preview</span>
      </div>
      <p className="asmt-lede">
        This is where the side-by-side would sit: your current allocation against
        the model an advisor selects, with growth of the same starting amount
        through both, and the difference in cost and concentration.
      </p>
      <div className="asmt-tiles" style={{ marginTop: 0 }}>
        <div className="asmt-tile">
          <div className="asmt-tile-label">Current</div>
          <div className="asmt-tile-value asmt-muted">
            {bundle?.holdings?.length ? `${bundle.holdings.length} positions` : 'Not analyzed'}
          </div>
        </div>
        <div className="asmt-tile">
          <div className="asmt-tile-label">Pure model</div>
          <div className="asmt-tile-value asmt-muted">Not connected</div>
          <div className="asmt-tile-note">needs a model portfolio selection</div>
        </div>
      </div>
    </section>
  );
}
